import React from 'react'
import { IonRow, IonCol, IonLabel, IonIcon } from '@ionic/react'
import { informationCircle } from 'ionicons/icons'
import './InfoBox.component.css'

interface IInfoBoxProps {
  text: string
}

const InfoBox: React.FC<IInfoBoxProps> = ({ text }) => {
  return (
    <IonRow className='info-box'>
      <IonCol size='12' className='info-box-content'>
        <IonIcon icon={informationCircle} className='info-box-icon' />
        <IonLabel className='info-box-text'>{text}</IonLabel>
      </IonCol>
    </IonRow>
  )
}

export default InfoBox
